import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Typography, Tag, Spin } from 'antd';

import { AuthorAdditionalInfo, getAuthorInfo } from '../api/Author';
import { getDisplayName } from './shared';
import { IPersonas } from './Personas';

const { Link } = Typography;

export const PersonaListItemDisplay = (props: IPersonas) => {
    const { id, year } = props;
    const [personaInfo, setPersonaInfo] = useState<AuthorAdditionalInfo>();
    const [loading, setLoading] = useState<boolean>(false);
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        setLoading(true);
        getAuthorInfo(id, year).then((response) => {
            setPersonaInfo(response);
            setLoading(false);
        });
    }, [id, year]);
    return (
        <>
            {loading ? (
                <span>
                    <Spin /> Loading…
                </span>
            ) : null}
            {!loading && personaInfo ? (
                <>
                    <div>
                        <Link
                            onClick={() => {
                                const queryParams = new URLSearchParams(location.search);
                                queryParams.set('a', id);
                                location.search = queryParams.toString();
                                history.push(location);
                            }}>
                            <span>{getDisplayName(personaInfo, true)}</span>
                        </Link>
                        {': '}
                    </div>
                    <div>
                        {personaInfo.task
                            ? personaInfo.task.slice(0, 3).map((term) => {
                                  return (
                                      <Tag key={term} color="purple">
                                          {term}
                                      </Tag>
                                  );
                              })
                            : null}
                        {personaInfo.method
                            ? personaInfo.method.slice(0, 3).map((term) => {
                                  return (
                                      <Tag key={term} color="blue">
                                          {term}
                                      </Tag>
                                  );
                              })
                            : null}
                    </div>
                </>
            ) : null}
        </>
    );
};
